import { Button, DatePicker, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefundRequestFilterFormField, RefundRequestFormValues } from './type';
import { payFormatDate } from 'utils/payload-date-';

const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
  formId: string;
  handleFilter: (values: RefundRequestFormValues) => void;
  initialValues: RefundRequestFormValues;
  closeModal?: () => void;
};

export const RefundFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: UsersFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<RefundRequestFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const onReset = () => {
    form.resetFields();
    handleFilter({ ...initialValues })
  };

  const onFinish = (formValues: RefundRequestFormValues) => {
    const formattedValues = {
      ...formValues,
      [RefundRequestFilterFormField.FromDate]: formValues?.FromDate && payFormatDate(formValues?.FromDate),
      [RefundRequestFilterFormField.ToDate]: formValues?.ToDate && payFormatDate(formValues?.ToDate),
    };
    handleFilter(formattedValues as any);
    closeModal?.();
  };

  return (

    <Form<RefundRequestFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper>
        <StandardItemsWrapper>
          <div className='invoice_list'>
            <Form.Item
              // label={t('shops.formfield.fieldName.label')}
              label={'User Name'}
              name={RefundRequestFilterFormField.USERNAME}
            >
              <Input placeholder={'Enter First Name'} />
            </Form.Item>
            <Form.Item
              // label={t('shops.formfield.fieldName.label')}
              label={'Event Name'}
              name={RefundRequestFilterFormField.EVENTNAME}
            >
              <Input placeholder={'Enter last name'} />
            </Form.Item>
            <Form.Item
              // label={t('shops.formfield.fieldName.label')}
              label={'Phone Number'}
              name={RefundRequestFilterFormField.MOBILENUMBER}
            >
              <Input placeholder={'Enter Phone Number'} />
            </Form.Item>

            <Form.Item
              // label={t('shops.formfield.fieldName.label')}
              label={'Status'}
              name={RefundRequestFilterFormField.STATUS}
            >
              <Select
                placeholder="Please slect status"
                options={[
                  { value: 'NULL', label: 'ALL' },
                  { value: '1', label: 'Approve' },
                  { value: '2', label: 'Reject' },
                  { value: '3', label: 'Pending' },
                ]}
              />
            </Form.Item>
            <Form.Item
              label={'Start Date'}
              name={RefundRequestFilterFormField.FromDate}
            >
              <DatePicker placeholder={"Start Date"}
                format="DD/MM/YYYY" // 👈 display format
              />
            </Form.Item>
            <Form.Item
              label={'End Date'}
              name={RefundRequestFilterFormField.ToDate}
            >
              <DatePicker placeholder={"End Date"}
                format="DD/MM/YYYY" // 👈 display format
              />
            </Form.Item>
            {screens.lg && (
              <ContentFilters.ButtonsWrapper className='filter_btn'>
                <Button type='primary' htmlType='submit'>
                  {t('common.buttons.filter', { count: 1 })}
                </Button>
                <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
              </ContentFilters.ButtonsWrapper>
            )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>

    </Form>
  );
};
